export const RAZZLE_DB_LINK: string =
  process.env.RAZZLE_DB_LINK || "https://unitiva.it/cms/";
export const RAZZLE_APP_PORTAL_LINK: string =
  process.env.RAZZLE_APP_PORTAL_LINK || "https://unitiva.it";
export const BREVO_ENDPOINT: string = 'https://api.brevo.com/v3/smtp/email';
export const REACT_APP_MAIL_KEY: string = process.env.REACT_APP_MAIL_KEY || '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';
